import React, { useState } from 'react'
import './signInFormPreview.css'

const ICON_URL =
  'https://secure-smartcfo.s3.us-east-2.amazonaws.com/images/public/logo/logo_no_background_donut.png'

function EyeOffIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1l22 22"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.53 9.53a3 3 0 0 0 4.24 4.24"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function EyeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2.2" />
    </svg>
  )
}

function ArrowUpRightIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M7 17L17 7"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7h10v10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/**
 * Vista previa estática del formulario de /signin (smart_front SignInForm).
 * Mismas clases `.scfo-login` que el portal; solo lectura en el admin.
 */
export default function SignInFormPreview() {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="scfo-login-scaler" aria-hidden="true">
      <div className="scfo-login">
      <div className="scfo-login__content">
        <div className="scfo-login__intro">
          <img className="scfo-login__icon" src={ICON_URL} alt="" />
          <span className="scfo-login__kicker">Te damos la bienvenida</span>
          <h1 className="scfo-login__title">Inicia sesión</h1>
          {/* <p className="scfo-login__subtitle">
            Gestiona las finanzas de tu empresa en un solo lugar.
          </p> */}
        </div>

        <form className="scfo-login__form" onSubmit={(e) => e.preventDefault()}>
          <div className="scfo-login__group">
            <label className="scfo-login__label" htmlFor="signin-preview-email">
              Correo electrónico
            </label>
            <input
              id="signin-preview-email"
              className="scfo-login__input"
              type="email"
              placeholder="correo@empresa.cl"
              defaultValue=""
              readOnly
              tabIndex={-1}
            />
          </div>

          <div className="scfo-login__group">
            <label className="scfo-login__label" htmlFor="signin-preview-password">
              Contraseña
            </label>
            <div className="scfo-login__password">
              <input
                id="signin-preview-password"
                className="scfo-login__input"
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••••••"
                defaultValue=""
                readOnly
                tabIndex={-1}
              />
              <button
                type="button"
                className="scfo-login__eye"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {showPassword ? <EyeIcon /> : <EyeOffIcon />}
              </button>
            </div>
          </div>

          <div className="scfo-login__error-slot" />

          <button type="button" className="scfo-login__button" tabIndex={-1}>
            <span className="scfo-login__button-text">Ingresar</span>
            <span className="scfo-login__arrow">
              <ArrowUpRightIcon />
            </span>
          </button>
        </form>

        <div className="scfo-login__links">
          <span className="scfo-login__link-preview">¿Olvidaste tu contraseña?</span>
        </div>
        </div>
      </div>
    </div>
  )
}
